/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Text, TextProps } from '@mantine/core'

function NoData (props: TextProps) {
  const { ...others } = props
  return (
    <Text
      inherit
      ta="center"
      p="sm"
      c="dimmed"
      {...others}
    >
      <FormattedMessage
        id="no_data"
        defaultMessage="Aucune donnée"
      />
    </Text>
  )
}

export default NoData
